import { Navigate } from "react-router-dom";
import { useSub } from "../../../common/subscription/useSub";
import { urls } from "../../../urls";
import { ContractSettings } from "./ContractSettings";

export const ContractSettingsRoute = () => {
  const sub = useSub();

  if (sub.hasSourcingEventV2Access) {
    return <Navigate to={`${urls.v2.settings}?tab=contract-types`} replace />;
  }

  return <ContractSettings />;
};
